import axios from 'axios';
import { getBuildNumber, getVersion } from 'react-native-device-info';
import { getWorkflowURI } from '../paths';
import { handleRetry, useAppPersistenceStore, useProfileStore } from '@ninjacart/nc-nk-store';
import { Platform } from 'react-native';
import { webBuildNumber } from '@ninjacart/nc-nk-core';

export const ProfileWorkflowClient = axios.create({
  baseURL: getWorkflowURI(),
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'x-build-number': Platform.OS === 'web' ? webBuildNumber : Number(getBuildNumber()),
    'x-platform': Platform.OS,
    'x-version-code': getVersion(),
    'Accept-Encoding': 'gzip',
    Authorization: `Bearer ${useProfileStore.getState().userProfile?.access_token}`,
    ...(useProfileStore?.getState()?.userProfile?.user?.id && {
      'x-nc-system-user-id': useProfileStore?.getState()?.userProfile?.user?.id,
    }),
    'x-language-code': useAppPersistenceStore?.getState()?.appLanguage,
  },
});

ProfileWorkflowClient.interceptors.request.use(async (config) => {
  // await syncStreamChannels();
  config.headers.Authorization = `Bearer ${useProfileStore.getState().userProfile?.access_token}`;
  config.headers['x-language-code'] = useAppPersistenceStore?.getState()?.appLanguage;

  // ProfileWorkflowClient.interceptors.request.eject(interceptor);
  return Promise.resolve(config);
});

ProfileWorkflowClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const config = error.config;
    return handleRetry(error, config, 'WORKFLOW_CLIENT_API_FAILED', ProfileWorkflowClient);
  }
);
